<!--C2-迭代需求 #42892（分期计算器H5设计）-->
<template>
  <div id="calculator">
    <div class="title-box">车家分期购车方案</div>
    <div class="switch-part">
      <p>手动输入</p>
      <van-switch v-model="checked" active-color="#378BFF" size="0.40rem"></van-switch>
    </div>
    <div class="table-box">
      <vcar-tr title="车型">
        <img :src="checkedInfoFormat.carBrandImgMin" class="car-img" />
        <div class="car-name">
          {{ checkedInfoFormat.carBrand }} {{ checkedInfoFormat.carSeriesName }}
          {{ checkedInfoFormat.carModelName }}
        </div>
        <div class="car-price">{{ fttPrice(checkedInfoFormat.carPrice) }}</div>
        <div class="select-car">
          <vcar-action-sheet :columns="carColumns" @change="carChange">
            <img
              src="../../assets/image/VcarCalculator/select-car.png"
              class="select-car-icon"
            />
          </vcar-action-sheet>
        </div>
      </vcar-tr>
      <vcar-tr
        :columns="downColumns"
        title="首付"
        name="down"
        :value="checkedInfoFormat.downRatio"
        unit="%"
        @change="downChange"
        :select-visible="checked"
        >
        {{ !checked?toThousands(checkedInfoFormat.downPayment):'' }}
        <input type="number" v-model.trim="checkedInfoFormat.downPayment" @input='downPaymentChange' v-show="checked"></input>
      </vcar-tr
      >
      <vcar-tr title="融资">{{
        toThousands(checkedInfoFormat.loanAoument)
      }}</vcar-tr>
      <vcar-tr
        :columns="balanceColumns"
        title="尾款"
        name="balance"
        :value="checkedInfoFormat.balanceRatio"
        unit="%"
        @change="balanceChange"
        :select-visible="checked"
        >
        {{ !checked?toThousands(checkedInfoFormat.balanceAoument):'' }}
        <input type="number" v-model.trim="checkedInfoFormat.balanceAoument" @input='balanceAoumentChange' v-show="checked"></input>
      </vcar-tr
      >
      <vcar-tr
        :columns="periodColumns"
        title="期限"
        name="period"
        :value="checkedInfoFormat.period"
        @change="periodChange"
        >{{ checkedInfoFormat.period }}期</vcar-tr
      >
      <vcar-tr title="费率">{{ checkedInfoFormat.feeRate }}%</vcar-tr>
      <vcar-tr title="月供">{{
        toThousands(checkedInfoFormat.monthAoument)
      }}</vcar-tr>
      <vcar-tr title="服务费"><span class="line-through">1000元</span></vcar-tr>
      <vcar-tr title="总利息">{{
        toThousands(checkedInfoFormat.interestAoument)
      }}</vcar-tr>
    </div>
  </div>
</template>

<script>
import VcarActionSheet from "./components/VcarActionSheet";
import VcarTr from "./components/VcarTr";
import { Toast, Switch } from "vant";
export default {
  data() {
    return {
      checked: false,
      balanceColumns: [0, 5, 10, 15, 20, 25, 30, 35, 40],
      downColumns: [10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80],
      periodColumns: [12, 24, 36, 48, 60],
      carColumns: [],
      visible: false,
      checkedInfo: {
        balanceRatio: "",
        downRatio: "",
        period: "",
        carBrand: "",
        carSeriesName: "",
        carModelName: "",
        carPrice: "",
        carBrandImgMin: ""
      },
      checkedInfoFormat: {},
      value: [],
    };
  },
  components: {
    VcarActionSheet,
    VcarTr,
  },
  watch: {
    checkedInfo(newValue, oldValue) {
      this.computePayment();
    },
    checked(newValue) {
      if(!newValue) {
        this.carChange(this.value)
      }
    }
  },
  mounted() {
    this.getCarsInfo();
  },
  methods: {
    downPaymentChange(e) {
      let checkedInfo = JSON.parse(JSON.stringify(this.checkedInfo));
      checkedInfo.downPayment = Number(e.target.value)
      const {downPayment, carPrice} = checkedInfo
      const { balanceAoument} = this.checkedInfoFormat
      if(downPayment + balanceAoument > carPrice) {
        this.checkedInfoFormat.downPayment = e.target.value.substr(0, e.target.value.length-1);
        Toast('首付尾款之和不高于车价')
        return
      }
      this.checkedInfo = checkedInfo
    },
    balanceAoumentChange(e) {
      let checkedInfo = JSON.parse(JSON.stringify(this.checkedInfo));
      checkedInfo.balanceAoument = Number(e.target.value)
      const { balanceAoument } = checkedInfo
      const { loanAoument } = this.checkedInfoFormat
      if(balanceAoument > loanAoument) {
        this.checkedInfoFormat.balanceAoument = e.target.value.substr(0, e.target.value.length-1);
        Toast('尾款不高于融资额度')
        return
      }
      this.checkedInfo = checkedInfo
    },

    getCarsInfo() {
      let that = this;
      Toast.loading({
        message: "加载中...",
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });
      that.$axios
        .post("/mybank/scheme/car/info", 'XP001')
        .then(function (res) {
          if (res.data && res.data.code === 0) {
            that.carColumns = res.data.data || [];
          }
        })
        .catch(function (error) {
          console.log("异常===", error);
        })
        .finally(function (error) {
          Toast.clear();
        });
    },
    showActionSheet() {
      this.visible = true;
    },
    hideActionSheet() {
      this.visible = false;
    },
    carChange(val) {
      let balanceColumns = val[2].remainLoanRate.split(";");
      let downColumns = val[2].downPaymentUnit.split(";");
      let periodColumns = [];
      for (var i = 0; i < val[2].loanPeriodList.length; i++) {
        periodColumns.push(val[2].loanPeriodList[i].loanPeriod);
      }
      this.checkedInfo = {
        carBrand: val[0].carBrand,
        carSeriesName: val[1].carSeriesName,
        carBrandImgMin: val[0].carBrandImgMin,
        ...val[2],
        //赋值默认值
        balanceRatio: balanceColumns[0],
        downRatio: downColumns[0],
        period: periodColumns[0],
      };
      periodColumns = this.minToMax(periodColumns);
      downColumns = this.minToMax(downColumns);
      balanceColumns = this.minToMax(balanceColumns);
      this.balanceColumns = balanceColumns;
      this.downColumns = downColumns;
      this.periodColumns = periodColumns;
      this.value = val;
    },
    fttPrice(val = 0) {
      let dividend = 10000;
      let curentNum = val / dividend;
      return curentNum.toFixed(2) + "万";
    },
    toThousands(num = 0) {
      var result = [],
        counter = 0;
      num = (num || 0).toString().split("");
      for (var i = num.length - 1; i >= 0; i--) {
        counter++;
        result.unshift(num[i]);
        if (!(counter % 3) && i != 0) {
          result.unshift(",");
        }
      }
      return result.join("");
    },
    balanceChange(val) {
      let checkedInfo = JSON.parse(JSON.stringify(this.checkedInfo));
      if (checkedInfo.period != 36 && val != 0) {
        Toast.fail("尾款产品仅限36期");
        return;
      }
      if (parseInt(checkedInfo.downRatio || 0) + parseInt(val) > 100) {
        Toast.fail("首付比尾款比之和须不大于100%");
        return;
      }
      checkedInfo.balanceRatio = val;
      this.checkedInfo = checkedInfo;
    },
    downChange(val) {
      let checkedInfo = JSON.parse(JSON.stringify(this.checkedInfo));
      if (parseInt(checkedInfo.balanceRatio || 0) + parseInt(val) > 100) {
        Toast.fail("首付比尾款比之和须不大于100%");
        return;
      }
      checkedInfo.downRatio = val;
      this.checkedInfo = checkedInfo;
    },
    periodChange(val) {
      let checkedInfo = JSON.parse(JSON.stringify(this.checkedInfo));
      if (checkedInfo.balanceRatio != 0 && val != 36) {
        Toast.fail("尾款产品仅限36期");
        return;
      }
      checkedInfo.period = val;
      this.checkedInfo = checkedInfo;
    },
    computePayment() {
      //在这里估算价格
      let checkedInfo = JSON.parse(JSON.stringify(this.checkedInfo));
      //首付
      checkedInfo.downPayment = this.getDownPayment(
        checkedInfo.carPrice,
        0,
        checkedInfo.downRatio,
        this.checkedInfoFormat.downPayment
      );

      checkedInfo.downRatio = this.getDownRatio(
        checkedInfo.carPrice,
        0,
        checkedInfo.downPayment,
        this.checkedInfo.downRatio
      )

      //融资
      checkedInfo.loanAoument = checkedInfo.carPrice - checkedInfo.downPayment;

      //尾款
      checkedInfo.balanceAoument = this.getBalancePayment(
        checkedInfo.loanAoument,
        checkedInfo.balanceRatio,
        this.checkedInfoFormat.balanceAoument
      );

      // 尾款比例
      checkedInfo.balanceRatio = this.getBalanceRatio(
        checkedInfo.loanAoument,
        checkedInfo.balanceAoument,
        this.checkedInfo.balanceRatio
      );

      //获取利率
      checkedInfo.feeRate = this.getFeeRate(
        checkedInfo.period,
        checkedInfo.loanPeriodList
      );
      //月供
      checkedInfo.monthAoument = this.getMonthlyPayment(
        checkedInfo.loanAoument,
        checkedInfo.balanceRatio,
        checkedInfo.period,
        checkedInfo.feeRate * (checkedInfo.period / 12)
      );
      //总利息
      checkedInfo.interestAoument =
        checkedInfo.monthAoument * checkedInfo.period +
        checkedInfo.balanceAoument +
        checkedInfo.downPayment -
        checkedInfo.carPrice;
      this.checkedInfoFormat = checkedInfo;
    },
    /**
     * 首付款计算
     */
    getDownPayment(carPrice, optionsSum, downPaymentRatio, val) {
      if(this.checked) {
        return Number(val)
      }
      let downPayment = 0;
      if (downPaymentRatio) {
        downPayment =
          Math.ceil((carPrice * downPaymentRatio) / 100) + parseInt(optionsSum);
      } else {
        downPayment = parseInt(optionsSum);
      }
      return downPayment;
    },

    /*
    * 首付比例
    * */
    getDownRatio(carPrice, optionsSum, downPayment, ratio) {
      if(!this.checked) {
        return ratio
      }
      let downPaymentRatio = 0;
      if (downPayment) {
        downPaymentRatio = Math.ceil((downPayment - parseInt(optionsSum))*100/carPrice * 100)/100;
      }
      return downPaymentRatio;
    },


    /**
     * 月供计算
     */
    getMonthlyPayment(loanAoument, finalPaymentRatio, period, feeRate) {
      let finalPayment = 0;
      // 尾款
      if (finalPaymentRatio) {
        finalPayment = Math.ceil(
          (parseInt(loanAoument) * finalPaymentRatio) / 100
        );
      }
      // 年费率
      let ratio = feeRate / (period / 12) / 100;
      //月供公式
      let monthlyPayment = Math.ceil(
        ((loanAoument - finalPayment) * (1 + (ratio * period) / 12)) / period +
          (finalPayment * ratio) / 12
      );
      return monthlyPayment;
    },

    /**
     *尾款
     */
    getBalancePayment(loanAoument, finalPaymentRatio) {
      if(this.checked) {
        return Number(this.checkedInfoFormat.balanceAoument)
      }
      let finalPayment = 0;
      if (finalPaymentRatio) {
        finalPayment = Math.ceil(
          (parseInt(loanAoument) * finalPaymentRatio) / 100
        );
      }
      return finalPayment;
    },
    /*
    * 尾款比例
    * */
    getBalanceRatio(loanAoument, finalPayment, ratio) {
      if(!this.checked) {
        return ratio
      }
      let finalPaymentRatio = 0;
      if (finalPayment) {
        finalPaymentRatio = Math.ceil(Number(finalPayment)*100/loanAoument*100)/100
      }
      return finalPaymentRatio;
    },

    getFeeRate(period, loanPeriodList = []) {
      let feeRate = 0;
      for (var i = 0; i < loanPeriodList.length; i++) {
        if (Number(loanPeriodList[i].loanPeriod) === Number(period)) {
          feeRate = loanPeriodList[i].feeRate;
          break;
        }
      }
      return feeRate;
    },
    minToMax(Arr = []) {
      var min;
      for (var i = 0; i < Arr.length; i++) {
        for (var j = i; j < Arr.length; j++) {
          if (Number(Arr[i]) > Number(Arr[j])) {
            min = Arr[j];
            Arr[j] = Arr[i];
            Arr[i] = min;
          }
        }
      }
      return Arr;
    },
  },
};
</script>

<style scoped>

.switch-part {
  padding: 0 0.24rem 0.14rem 0.24rem;

  display: flex;
  justify-content: flex-end;

}

.switch-part > p {
  margin-right: 0.2rem;
  font-size: 0.28rem;
  color: #858689;
  letter-spacing: 0;
  text-align: center;
  line-height: 0.4rem;
}

/deep/.van-switch {
  border-width: 0;
  box-shadow: 0 0 0 1px rgba(0,0,0,.1);
}


page {
  background: #ffffff;
}

#calculator {
  width: 100%;
  padding: 0 0 0.9rem 0;
  width: 7.5rem;
  margin: 0 auto;
}

#calculator div {
  box-sizing: border-box;
}

#calculator > .title-box {
  width: 100%;
  padding: 0.524rem 0 0.34rem 0;
  font-family: PingFangSC-Semibold;
  font-size: 0.4rem;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  line-height: 0.4rem;
  font-weight: 500;
}

#calculator > .table-box {
  width: 100%;
  padding: 0px 0.24rem;
}

.car-img {
  width: 1.96rem;
  height: auto;
}

.car-name {
  width: 100%;
  margin-top: 0.2rem;
  font-size: 0.26rem;
  line-height: 0.32rem;
  text-align: justify;
}

.car-price {
  width: 100%;
  margin-top: 0.13rem;
  color: #ff6932;
  font-family: PingFangSC-Medium;
}

.select-car {
  position: absolute;
  top: 0.45rem;
  right: 0.35rem;
}

.select-car-icon {
  width: 0.64rem;
  height: 0.64rem;
  cursor: pointer;
}

.line-through {
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/components/VcarCalculator/index.vue